import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { xToastr as Toastr, ToastrTypes, xToastr } from '../../../shared/Toastr';
import { ssApiService } from 'app/services/ss-api.service';
import { ResetPasswordRequest } from 'app/models/ss-api/requests/reset.password.request';

@Component({
    selector: 'forgot-password',
    templateUrl: './forgot-password-form.component.html',
})
export class ForgotPasswordFormComponent implements OnInit {

    @Output('onCancel') onCancel = new EventEmitter();

    @Output('setBusy') setBusy = new EventEmitter();
    @Output('setNotBusy') setNotBusy = new EventEmitter();

    Email: string;

    constructor(private api: ssApiService) {

    }

    ngOnInit() {
        let email = localStorage.getItem('email');

        if (email) {
            this.Email = email;
        }
    }

    public Cancel() {
        this.onCancel.emit();
    }

    setIsBusy(IAmBusy: boolean) {
        if (IAmBusy) {
            this.setBusy.emit();
        } else {
            this.setNotBusy.emit();
        }
    }



    public ResetPassword() {

        let request = new ResetPasswordRequest();
        request.Checksum = 'SDFHSDKFHsdlkfhsdlfhl2we4r8w74esFSDFKHDKDSFhwoehlsdf2546546!!!Fausto.sDFSDCaltabiano';
        request.Email = this.Email;

        this.setIsBusy(true);

        let subscription = this.api.ResetPasswordRequest(request).subscribe(
            (result) => {
                subscription.unsubscribe();

                let toastOptions = {
                    closeButton: true,
                    progressBar: true,
                    debug: true,
                    preventDuplicates: true,
                    positionClass: 'toast-top-center',
                    onclick: null,
                    showDuration: 400,
                    hideDuration: 1000,
                    timeOut: 10000,
                    extendedTimeOut: 5000,
                    showEasing: 'swing',
                    hideEasing: 'linear',
                    showMethod: 'fadeIn',
                    hideMethod: 'fadeOut'
                };

                xToastr.ShowToast(ToastrTypes.Success, 'Request Completed', '<p>An email has been sent to <strong>' + this.Email + '</strong>. Follow the link in the email to reset your password.</p>', toastOptions);

                // check result
                if (!result.Result) {
                    // return;
                }

                // ok
                // -> change ui here
                this.setIsBusy(false);
                this.Cancel();
            },
            (error) => {
                // error
                xToastr.ShowToast(ToastrTypes.Error, 'Error', error);
            }
        );

    }
}
